import { render } from "./publicPage.vue?vue&type=template&id=a299b7b6"
import script from "./publicPage.vue?vue&type=script&lang=js"
export * from "./publicPage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__